import React, { useRef, forwardRef } from 'react';
import ClassNames from "classnames";
import { KEY_VALUES, useControlled } from '../utils';
var Progress = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    activeIndexProp = props.activeIndex,
    _props$defaultActiveI = props.defaultActiveIndex,
    defaultActiveIndex = _props$defaultActiveI === void 0 ? 0 : _props$defaultActiveI,
    _props$space = props.space,
    space = _props$space === void 0 ? 84 : _props$space,
    _props$steps = props.steps,
    steps = _props$steps === void 0 ? [] : _props$steps,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    _props$readonly = props.readonly,
    readonly = _props$readonly === void 0 ? false : _props$readonly,
    children = props.children,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    className = props.className,
    onActiveIndexChange = props.onActiveIndexChange;
  var _useControlled = useControlled(activeIndexProp, defaultActiveIndex),
    activeIndex = _useControlled[0],
    setActiveIndex = _useControlled[1];
  var progressRef = useRef(null);
  var renderHeader = function renderHeader() {
    var results = [];
    steps.forEach(function (step, index) {
      if (!step) {
        return;
      }
      var currentIndex = activeIndex < steps.length ? activeIndex : steps.length - 1;
      var itemClick = function itemClick(event) {
        if (readonly) {
          event.preventDefault();
          return;
        }
        setActiveIndex(index);
        onActiveIndexChange === null || onActiveIndexChange === void 0 ? void 0 : onActiveIndexChange(index);
      };
      var isActive = function isActive() {
        return index <= currentIndex;
      };
      var classTextNames = ClassNames('', {
        'active': isActive(),
        'ap-font-medium': isActive()
      });
      results.push( /*#__PURE__*/React.createElement("li", {
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        role: "tab",
        id: 'progress-' + step,
        className: "ap-progress-mark-text",
        "aria-selected": index === currentIndex,
        "aria-controls": 'panel-' + step,
        "aria-hidden": readonly && index !== currentIndex ? true : false,
        tabIndex: index === currentIndex ? 0 : -1,
        onClick: itemClick
      }, /*#__PURE__*/React.createElement("span", {
        className: classTextNames
      }, step))));
    });
    return results;
  };
  var renderContent = function renderContent() {
    var results = [];
    steps.forEach(function (step, index) {
      if (!step) {
        return;
      }
      results.push( /*#__PURE__*/React.createElement("div", {
        key: index,
        hidden: index !== activeIndex,
        id: 'panel-' + step,
        "aria-labelledby": 'progress-' + step
      }));
    });
    return results;
  };
  var classProgressNames = ClassNames('ap-progress', className, {
    'is-horizontal': orientation === 'horizontal',
    'is-vertical': orientation === 'vertical',
    'ap-progress-readonly': readonly
  });
  var progressStyle = space && steps.length ? orientation == 'horizontal' ? Object.assign({
    'width': space * (steps.length - 1) + "px"
  }, style) : Object.assign({
    'height': space * (steps.length - 1) + "px"
  }, style) : style;
  var progressBarStyle = orientation == 'horizontal' ? {
    'width': activeIndex / (steps.length - 1) * 100 + "%"
  } : {
    'height': activeIndex / (steps.length - 1) * 100 + "%"
  };
  var onKeyDown = function onKeyDown(event) {
    var _progressRef$current;
    var stepNum = steps.length;
    var stepsEle = (_progressRef$current = progressRef.current) === null || _progressRef$current === void 0 ? void 0 : _progressRef$current.querySelectorAll('.ap-progress-mark-text');
    if (stepNum === 0 || readonly || !stepsEle || stepsEle.length === 0) return;
    var key = event.key;
    var nextFocusIndex = activeIndex;
    var target = event.target;
    if (key === KEY_VALUES.RIGHT) {
      event.preventDefault();
      if (activeIndex < stepNum - 1) {
        var _target$parentElement, _target$parentElement2;
        nextFocusIndex = activeIndex + 1;
        (_target$parentElement = target.parentElement.nextElementSibling) === null || _target$parentElement === void 0 ? void 0 : (_target$parentElement2 = _target$parentElement.firstElementChild) === null || _target$parentElement2 === void 0 ? void 0 : _target$parentElement2.focus();
      } else if (activeIndex === stepNum - 1) {
        var _target$parentElement3, _target$parentElement4;
        nextFocusIndex = 0;
        (_target$parentElement3 = target.parentElement.parentElement.firstElementChild) === null || _target$parentElement3 === void 0 ? void 0 : (_target$parentElement4 = _target$parentElement3.firstElementChild) === null || _target$parentElement4 === void 0 ? void 0 : _target$parentElement4.focus();
      }
    } else if (key === KEY_VALUES.LEFT) {
      event.preventDefault();
      if (activeIndex > 0 && activeIndex <= stepNum - 1) {
        var _target$parentElement5, _target$parentElement6;
        (_target$parentElement5 = target.parentElement.previousElementSibling) === null || _target$parentElement5 === void 0 ? void 0 : (_target$parentElement6 = _target$parentElement5.firstElementChild) === null || _target$parentElement6 === void 0 ? void 0 : _target$parentElement6.focus();
        nextFocusIndex = activeIndex - 1;
      } else if (activeIndex === 0) {
        var _target$parentElement7, _target$parentElement8;
        (_target$parentElement7 = target.parentElement.parentElement.lastElementChild) === null || _target$parentElement7 === void 0 ? void 0 : (_target$parentElement8 = _target$parentElement7.firstElementChild) === null || _target$parentElement8 === void 0 ? void 0 : _target$parentElement8.focus();
        nextFocusIndex = stepNum - 1;
      }
    }
    if (key === KEY_VALUES.LEFT || key === KEY_VALUES.RIGHT) {
      setActiveIndex(nextFocusIndex);
      onActiveIndexChange === null || onActiveIndexChange === void 0 ? void 0 : onActiveIndexChange(nextFocusIndex);
      // (stepsEle[nextFocusIndex] as HTMLElement)?.focus();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: classProgressNames,
    style: progressStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-progress-bar",
    style: progressBarStyle
  }), /*#__PURE__*/React.createElement("ul", {
    //@ts-ignore
    ref: progressRef,
    role: "tablist",
    className: "ap-progress-mark",
    onKeyDown: onKeyDown
  }, renderHeader()), renderContent());
});
Progress.displayName = 'Progress';
export default Progress;